export type Sorter<T> = (a: T, b: T) => number;

export default function sortBy<T>(...sorters: Sorter<T>[]) {
  // eslint-disable-next-line func-names
  return function (a: T, b: T): number {
    return sorters.reduce((previous, sorter) => previous || sorter(a, b), 0);
  };
}
